<!-- 搜索页面 -->
<template>
  <div class="search">
    <!-- 搜索框 -->
    <div class="search-box">
      <input v-model="keyword" type="text" />
      <div class="serchbtn"></div>
      <span class="onCancle" @click="onCancle()">取消</span>
    </div>
    <!-- 搜索内容 -->
    <div class="searchContent">
      <div
        class="sContent"
        v-for="(item, index) in searchData"
        :key="index"
        v-show="searchShow"
      >
        <div class="scenicItem" @click="backPrev()">
          <div class="leftItem">
            <div class="itemIcon">
              <img :src="$global.ImgUrl + item.img" alt="" />
            </div>
            <div class="itemName">{{ item.name }}</div>
          </div>
          <div class="rightItem">{{ item.typeName }}</div>
        </div>
      </div>
      <div class="noResult" v-show="noResultShow">
        查不到相关数据，换个词试试~
      </div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { searchApi } from "../../request/api/index";
// 节流函数
const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      keyword: "", //搜索框输入的内容
      searchData: [], //搜索的数据
      searchShow: false, //显示搜索的内容
      noResultShow: false, //搜索不到结果
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {
    //watch title change
    keyword() {
      delay(() => {
        const value = this.keyword.trim();
        if (!value) {
          //判断输入框的值是否为空  如果为空 直接返回不在执行
          this.searchShow = false;
          return;
        } else {
          this.getSearchData(); //获取搜索的内容
        }
      }, 300);
    },
  },
  //方法集合
  created() {},
  methods: {
    //取消
    onCancle() {
      this.$router.push("/");
    },
    //请求全域搜索的数据
    getSearchData() {
      searchApi(this.keyword).then((res) => {
        // console.log(res);
        this.searchData = res.data;
        console.log(this.searchData);
        if (this.searchData.length == 0) {
          this.noResultShow = true;
          this.searchShow = false;
        } else {
          console.log(111);
          this.searchShow = true;
          this.noResultShow = false;
        }
      });
    },
    //返回上一页打开相对应的景点
    backPrev() {
      this.$router.push("/index");
    },
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang="less">
.search {
  width: 100%;
  height: 100vh;
  background: #fafafa;
  padding: 0.9rem 1.6rem 0;
  position: relative;
  //搜索框
  .search-box {
    width: 100%;
    height: 3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0.5rem 0;
    position: relative;
    input {
      width: 30rem;
      height: 4.4rem;
      background: #ffffff;
      border-radius: 4.4rem;
      padding-left: 3rem;
      border: #fff;
      outline: none;
    }
    input:focus {
      outline: none;
    }
    .serchbtn {
      width: 2.4rem;
      height: 2.4rem;
      background: url("./image/icon_search.svg") no-repeat;
      background-size: 100%;
      position: absolute;
      top: 0.2rem;
      left: 0.5rem;
    }
    .onCancle {
      width: 4rem;
      height: 3rem;
      font-size: 1.6rem;
      border-radius: 3rem;
      font-weight: 500;
      text-align: center;
      line-height: 3rem;
      color: #43525c;
    }
  }
  //搜索内容
  .searchContent {
    width: 100%;
    .sContent {
      width: 100%;
      height: 5rem;
      border-bottom: 1px solid #eee;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      .scenicItem {
        width: 100%;
        height: 3rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .leftItem {
          display: flex;
          .itemIcon {
            width: 2.2rem;
            height: 2.2rem;
            margin-right: 0.5rem;
          }
          .itemName {
            height: 2.2rem;
            line-height: 2.2rem;
            font-size: 1.6rem;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            text-align: LEFT;
            color: #333333;
            letter-spacing: 0rem;
          }
        }
        .rightItem {
          height: 2.2rem;
          font-size: 1.4rem;
          font-family: Source Han Sans CN, Source Han Sans CN-Normal;
          font-weight: Normal;
          color: #666666;
          line-height: 2.2rem;
          letter-spacing: 0rem;
        }
      }
    }
    .noResult {
      height: 3rem;
      line-height: 3rem;
      margin-left: 7rem;
    }
  }
}
</style>